import { useState, useEffect } from "react";

const useBrowserClass = (): string => {
    const [browserClass, setBrowserClass] = useState<string>("");
    useEffect(() => {
        const ua = navigator.userAgent;

        const isChrome = /Chrome/.test(ua) && !/Edg|OPR|Brave/.test(ua);
        const isSafari = /Safari/.test(ua) && !/Chrome/.test(ua);
        const isFirefox = /Firefox/.test(ua);

        if (isChrome) {
            //document.body.classList.add("browser-chrome");
            setBrowserClass("browser-chrome");
        } else if (isSafari) {
            //document.body.classList.add("browser-safari");
            setBrowserClass("browser-safari");
        } else if (isFirefox) {
            //document.body.classList.add("browser-firefox");
            setBrowserClass("browser-firefox");
        }
    }, []);
    return browserClass;
};

export default useBrowserClass;
